import { render, staticRenderFns } from "./LegalNavigation.vue?vue&type=template&id=56dc2a7a&"
import script from "./LegalNavigation.vue?vue&type=script&lang=js&"
export * from "./LegalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports